export const INITIAL_PERIOD = 'next1y';

export const DIVIDEND_QUALITY_PERIOD_KEYS = [
  'past1y',
  INITIAL_PERIOD,
  'next2y',
  'next3y',
] as const;
